import { render, staticRenderFns } from "./VocabularyWordsRusPreview.vue?vue&type=template&id=4cefa99f&lang=pug&"
import script from "./VocabularyWordsRusPreview.vue?vue&type=script&lang=js&"
export * from "./VocabularyWordsRusPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports